<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" id="ch8" title="How Did the Term “Yankee” Originate?">
<p class="h2a"><a href="#/text/Contents#rch8">How Did the Term “Yankee” Originate?</a></p>
<p class="noindent1">“Yankee,” and its contracted form “Yank,” are slang terms used to refer to people from the United States. Within the country, the term applies to people from the northeastern states that were once part of the Union in the American Civil War, while outside the United States, it is used informally to refer to any American.</p>
<p class="indent">The term Yankee has a number of suggested etymologies. One is that it derives from a British officer who said that the Cherokee word <i>eankke</i>, pronounced like Yankee and meaning “coward,” was used by the Native Americans to refer to the settlers. This is incorrect; no such word exists in the Cherokee language. Another theory is that it derives from a Native American mispronunciation of <i>l’anglais</i>, the French word for English, as “Yengees.” Most linguists reject this origin as false, as well.</p>
<p class="indent">The likely origin of the term dates from the 1680s. The Dutch settlers in New Amsterdam (now New York), applied the name “Jan Kees” to their rival Dutch colonial neighbors in Connecticut. This term is thought to be based on the name “Jan Kaas,” a disparaging nickname translated as “John Cheese” that the Flemish had used for Dutchmen generally. Pronounced in Dutch as “Yankees,” it evolved to include the English-speaking colonists as well, eventually being used for all Americans.</p>
<p class="indent">The term became widespread as a result of the song “Yankee Doodle,” which was popular with both the American and the British troops during the American War of Independence in the late 1700s.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter008.vue?90803658